import { AreaOfWork } from "./areaOfWork.model";

export class Development {
  constructor(
    public id: number,
    public name: string,
    public address: string,
    public borough: string,
    public district: string,
    public latitude: string,
    public longitude: string,
    public areasOfWork: AreaOfWork[] = [],
    public totalInvestment: number = 0,
    public developmentPicture: string = "",
    public noOfUnits: number = 0,
    public includeExclude: string = "Include",
  ) {
    this.totalInvestment = +parseFloat(
      areasOfWork
        .flatMap((a) =>
          a.projects
            .filter((x) => x.otherDevelopments.length <= 1)
            .flatMap((z) => z)
            .reduce((acc, current) => acc + current.projectTotalBudget, 0),
        )
        .reduce((a, b) => a + b, 0) + "",
    ).toFixed(2);
  }

  getFiveYearCapitalNeeds(): number {
    return this.areasOfWork.reduce((acc, current) => {
      return acc + current.fiveYearCapitalNeeds;
    }, 0);
  }

  getTwentyYearCapitalNeeds(): number {
    return this.areasOfWork.reduce((acc, current) => {
      return acc + current.twentyYearCapitalNeeds;
    }, 0);
  }
}

export interface legendColorCollection {
  legendName: string;
  colorCoding: string;
}

export interface imageLoad {
  imgPath: string;
  height: number;
  width: number;
}
